<template>
  <el-select
    ref="elSelect"
    v-model="selectValue"
    :placeholder="placeholder"
    :filterable="filterable"
    :clearable="clearable"
    :disabled="disabled"
    :multiple="multiple"
    :multiple-limit="multipleLimit"
    :remote="remote"
    :remote-method="remoteMethod"
    :value-key="valueKey"
    size="small"
    :popper-class="'select-option'"
    class="has-company-icon"
    @change="handleChange"
    @focus="focus"
    @visible-change="handlerVisibleChange"
  >
    <template
      v-if="icon"
      slot="prefix">
      <font-awesome-icon
        class="icon"
        :icon="[iconType, icon]" />
    </template>
    <template v-if="group">
      <el-option-group
        v-for="group in list"
        :key="group.label"
        :label="group.label">
        <el-option
          v-for="item in group.options"
          :key="item[valueKey]"
          :label="item[labelKey]+(labelSecondKey?`${showName?'':'-'} ${item[labelSecondKey]}`:'')"
          :value="item[valueKey]">
        </el-option>
      </el-option-group>
    </template>
    <template v-else-if="disableKey">
      <el-option
        v-for="(option, index) in list"
        :key="index"
        :label="isRenewType?renewFileTypeName[option.valueKey]:option[labelKey]+(labelSecondKey?`${showName?'':'-'} ${option[labelSecondKey]}`:'')"
        :value="option[valueKey]"
        :disabled="!option[disableKey]"
      >
        <slot :item="option" />
      </el-option>
    </template>
    <template v-else-if="nameGroup">
      <template v-for="(option, index) in list">
        <el-option
          v-if="option[labelKey] == ' '"
          :key="index"
          class="unname"
          label="Unnamed Account"
          :value="option[valueKey]"
        >
          <slot :item="option" />
        </el-option>
        <el-option
          v-else
          :key="index"
          :label="option[labelKey]+(labelSecondKey?`${showName?'':'-'} ${option[labelSecondKey]}`:'')"
          :value="option[valueKey]"
        >
          <slot :item="option" />
        </el-option>
      </template>
    </template>
    <template v-else>

      <el-option
        v-for="(option, index) in list"
        :key="index"
        :class="{'has-icon':hasIcon}"
        :style="{'width':width}"
        :label="isRenewType?renewFileTypeName[`${option[valueKey]}`]:option[labelKey]+(labelSecondKey?`${showName?'':'-'} ${option[labelSecondKey]}`:'')"
        :value="option[valueKey]"
      >
        <slot :item="option" />
      </el-option>

    </template>
  </el-select>
</template>

<script>
import {renewFileTypeName} from '@/utils/renew_type'
export default {
  name: 'VSelect',
  props: {
    value: {
      type: [String, Number, Array],
      default: ''
    },
    remoteMethod:{
      type:Function
    },
    list: {
      type: Array,
      default: () => ([])
    },
    labelKey: {
      type: String,
      default: 'name'
    },
    labelSecondKey: {
      type: String,
      default: ''
    },
    valueKey: {
      type: String,
      default: 'id'
    },
    placeholder: {
      type: String,
      default: ''
    },
    filterable: {
      type: Boolean,
      default: true
    },
    showType: {
      type: Boolean,
      default: false
    },
    remote: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: ''
    },
    iconType: {
      type: String,
      default: 'fas'
    },
    group: {
      type: Boolean,
      default: false
    },
    disableKey:{
      type: String,
      default: ''
    },
    multiple: {
      type: Boolean,
      default: false
    },
    multipleLimit: {
      type: Number,
      default: 0
    },
    nameGroup: {
      type: Boolean,
      default: false
    },
    hasIcon: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: '100%'
    },
    passwordType:{
      type: Boolean,
      default: false
    },
    noList:{
      // 某些清空下没有列表需要直接赋值，不然会被清空 例如coupon list
      type: Boolean,
      default: false
    },
    index:{
      type:Number,
      default:0
    },
    isSelectFirst:{
      type: Boolean,
      default: false
    },
    isString:{
      type: Boolean,
      default: false
    },
    showName:{
      type: Boolean,
      default: false
    },
    isRemoteKey:{
      type: Boolean,
      default: false
    },
    remoteName:{
      type: String,
      default: ''
    },
    isRenewType:{
      type: Boolean,
      default: false
    },
    isCompany: {
      type: Boolean,
      default: false
    },
    isCAR: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      selectValue: ''
    }
  },
  computed: {
    isNumber() {
      if(!(this.list instanceof Array) || this.list.length == 0 ) {
        return false
      }
      let id = this.group? this.list[0].options[0][this.valueKey]: this.list[0][this.valueKey]
      return typeof id === 'number'? true: false
    },
    renewFileTypeName(){
      let type_name = renewFileTypeName
      if(this.isCompany)
        type_name.id_type_pic_path = 'Certificate of Incorporation/Business Registration Certificate'
      if(this.isCAR)
        type_name.mpf_files = 'Others / Supporting Doc'
      return type_name
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(val, old) {
        if(val === '') {
          this.selectValue = ''
          if(this.isSelectFirst)
            this.handleValue()
        }
        else if(this.noList){
          this.selectValue = val
        }
        // let type = typeof this.selectValue === typeof this.list[0][this.valueKey]
        else if(JSON.stringify(val) != JSON.stringify(this.selectValue)) {
          // else if (val !== this.selectValue ) {
          this.handleValue(val)
        }
        // if(val !== old) {
        //   this.handleValue(val)
        // }
      }
    },
    list: {
      deep: true,
      handler(val) {
        if(val && val.length > 0) {
          this.handleValue(this.selectValue)
        }
      }
    },
    showType: {
      immediate: true,
      handler(val) {
        this.$nextTick(()=>{
          this.changeInputType()
        })
      }
    },
    selectValue(val) {
      this.$emit('input', val,this.index)
    }
  },
  mounted() {
    // console.log([this.$refs.elSelect.$refs.reference])

    if(this.isSelectFirst&&this.list.length>0){
      this.selectValue = this.list[0][this.valueKey]
      this.$emit('input', this.list[0][this.valueKey])
    }

  },
  methods: {
    changeInputType(){
      if(!this.passwordType) return
      let type = this.$refs.elSelect.$refs.reference.$el.firstElementChild.type
      this.$refs.elSelect.$refs.reference.$el.firstElementChild.type = type=='password'?'text':'password'
      this.$refs.elSelect.$refs.reference.$el.firstElementChild.autocomplete = type=='password'?'off ':'new-password'
    },
    handlerVisibleChange(status) {
      // remote 時點擊當前項默認選了第一個
      // 估計是 element 的鍋，這裏避開
      if(this.remote && !status) {
        const value = this.selectValue
        this.selectValue = ''
        setTimeout(() => {
          this.selectValue = value
        }, 0)
      }
    },
    handleChange(val) {
      this.$emit('input', val)
      this.$emit('change', val,this.index)
      this.$emit('changeData', this.getOptionData(val))
    },
    handleValue(value) {
      let flag = this.selectValue === ''
      // 排除外部干擾
      let list = this.list? this.list: []

      // 传空字符串的时候会默认选到0
      // const val = this.isNumber? Number(value): String(value)
      // 先用这个看看会不会出现其他问题
      const val = value
      let result
      if(this.group) {
        list.some(group => {
          result = group.options.filter(item => item[this.valueKey] === val)
          if(result.length > 0) {
            return true
          }
        })
      }
      else if(this.multiple) {
        if(value.length > 0 && this.list.length > 0) {
          result = value.reduce((result, item) => {
            const check = this.list.filter(subItem => subItem.id == item)
            if(check.length > 0) {
              result.push(item)
            }
            return result
          }, [])
          this.selectValue = result
        }else if(value.length === 0){
          this.selectValue = []
        }
        this.$emit('input', this.selectValue)
        return
      }
      else {
        result = list.filter(item => String(item[this.valueKey]) === String(val))
      }
      // 转number的时候会把前面的0给去掉，所以得转回字符串再判断一次
      let v = isNaN(Number(val)) || Number(val).toString() != val? val : Number(val)
      this.selectValue = result.length > 0 ? v : ''
      if(this.isString){
        this.selectValue = this.selectValue.toString()
      }
      if(flag && this.selectValue === '') {
        this.$emit('input', this.selectValue)
      }
      if(this.isRemoteKey&&list.length>0){
        let remote_obj = list[0]||{}
        this.$emit('update:remoteKey',remote_obj[this.remoteName])
      }
      if(this.isSelectFirst){
        this.selectValue = list[0][this.valueKey]
        this.$emit('input', list[0][this.valueKey])
      }
    },
    getOptionData(val) {
      let result = {}
      this.list.some(item => {
        if(this.group) {
          let groupResult = item.options.filter(option => option[this.valueKey] == val)
          if(groupResult.length > 0) {
            result = groupResult[0]
            return true
          }
        }
        else {
          if (item[this.valueKey] == val) {
            result = item
            return true
          }
        }
        return false
      })

      return result
    },
    focus(){
      this.$emit('focus')
    }
  }
}
</script>

<style lang="scss" scoped>
.el-select {
  width: 100%;
  /deep/ .el-input__prefix {
    display: flex;
    align-items: center;
    padding-left: 3px;
    height: 100%;
  }
  .svg-inline--fa {
    font-size: 16px;
  }

}

</style>

<style lang="scss" scoped>
.el-select-dropdown__item {
  height: auto;
  line-height: auto;
  //width: 330.641px!important;
  &.has-icon{
    height: 34px;
  }
  span{
    width: 330.641px!important;
    display: block;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .send-info {
    padding-bottom: 5px;
    span {
      display: block;
      line-height: 15px;
      font-size: 12px;
    }
  }
}
.unname {
  font-style: italic;
  color: #6A737D;
}
</style>
